import React from "react";
import "./FeaturesSection.css";

const FeaturesSection = () => {
  return (
    <section className="features-section-main-wrapper-container">
      <div className="features-section-content-max-width-container">
        <div className="features-section-header-content-wrapper">
          <h2 className="features-section-main-title-heading">Une solution complète</h2>
          <p className="features-section-subtitle-description-text">
            Découvrez pourquoi Monagora est le choix de milliers d'entreprises
          </p>
        </div>
        
        <div className="features-section-grid-container-layout">
          <div className="features-section-individual-feature-card">
            <div className="features-section-feature-icon-container">🚀</div>
            <h3 className="features-section-feature-title-heading">Automatisation complète</h3>
            <p className="features-section-feature-description-text">
              Prise de rendez-vous entièrement automatisée pour gagner un temps précieux
            </p>
            <ul className="features-section-feature-points-list-container">
              <li className="features-section-feature-point-list-item">
                <span className="features-section-feature-point-text-content">Planification intelligente</span>
              </li>
              <li className="features-section-feature-point-list-item">
                <span className="features-section-feature-point-text-content">+200% efficacité</span>
              </li>
              <li className="features-section-feature-point-list-item">
                <span className="features-section-feature-point-text-content">Zéro intervention manuelle</span>
              </li>
            </ul>
          </div>
          
          <div className="features-section-individual-feature-card">
            <div className="features-section-feature-icon-container">⚡</div>
            <h3 className="features-section-feature-title-heading">IA optimisée</h3>
            <p className="features-section-feature-description-text">
              Intelligence artificielle qui apprend et s'adapte à vos habitudes de travail
            </p>
            <ul className="features-section-feature-points-list-container">
              <li className="features-section-feature-point-list-item">
                <span className="features-section-feature-point-text-content">Apprentissage continu</span>
              </li>
              <li className="features-section-feature-point-list-item">
                <span className="features-section-feature-point-text-content">-40% temps perdu</span>
              </li>
              <li className="features-section-feature-point-list-item">
                <span className="features-section-feature-point-text-content">Adaptation automatique</span>
              </li>
            </ul>
          </div>
          
          <div className="features-section-individual-feature-card">
            <div className="features-section-feature-icon-container">💰</div>
            <h3 className="features-section-feature-title-heading">Économies garanties</h3>
            <p className="features-section-feature-description-text">
              Réduction des coûts opérationnels grâce à l'optimisation des déplacements
            </p>
            <ul className="features-section-feature-points-list-container">
              <li className="features-section-feature-point-list-item">
                <span className="features-section-feature-point-text-content">Optimisation trajets</span>
              </li>
              <li className="features-section-feature-point-list-item">
                <span className="features-section-feature-point-text-content">15K€+ économisés/an</span>
              </li>
              <li className="features-section-feature-point-list-item">
                <span className="features-section-feature-point-text-content">ROI garanti</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection; 